import React from 'react';
import { Crown, LucideIcon } from 'lucide-react';
import { useSettingsModal } from '../../contexts/SettingsModalContext';

interface FeatureUpgradePromptProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const FeatureUpgradePrompt: React.FC<FeatureUpgradePromptProps> = ({
  icon: Icon,
  title,
  description,
}) => {
  const { openAccountSettings } = useSettingsModal();

  return (
    <div className="p-8 bg-gradient-to-br from-brand-primary/5 to-brand-primary/10 dark:from-brand-primaryDarkMode/5 dark:to-brand-primaryDarkMode/10 rounded-xl border-2 border-brand-primary/20 dark:border-brand-primaryDarkMode/20">
      <div className="flex flex-col items-center text-center">
        <div className="w-16 h-16 bg-brand-primary/10 dark:bg-brand-primaryDarkMode/10 rounded-full flex items-center justify-center mb-4">
          <Icon className="w-8 h-8 text-brand-primary dark:text-brand-primaryDarkMode" />
        </div>
        <h3 className="text-xl font-semibold text-neutral-900 dark:text-white mb-2">
          {title}
        </h3>
        <p className="text-neutral-600 dark:text-neutral-400 mb-6 max-w-md">
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => openAccountSettings('plan')}
            className="inline-flex items-center px-6 py-3 bg-brand-action hover:bg-brand-action-hover text-brand-action-text rounded-lg font-medium transition-colors shadow-sm"
          >
            <Crown className="w-5 h-5 mr-2" />
            View Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureUpgradePrompt;
